import React, { useRef } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  registerables as registerablesJS,
  InteractionItem,
} from 'chart.js';
import { Color, ChartDataSet } from '../../types/app/chart.types';
import { Chart, getElementAtEvent } from 'react-chartjs-2';
import ResizableBox from '../../components/app/ResizableBox/ResizableBox';
import { ThemeType } from '../../hooks/useLocalTheme';
import { GRAY } from '../../utils/core/functions/colors.function';

ChartJS.register(...registerablesJS);
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
);

interface Props {
  chartData: ChartDataSet[];
  labels: string[];
  displayLegend?: boolean;
  chartHeight?: string;
  chartWidth?: string;
  chartTitle?: string;
  onClick?: (result: InteractionItem[]) => void;
  localTheme?: ThemeType;
}

export function ChartsContainerHistory({
  chartData,
  labels,
  displayLegend = true,
  chartHeight,
  chartWidth,
  chartTitle,
  onClick,
  localTheme,
}: Props) {
  const chartRef = useRef();
  const preparedData = {
    labels,
    datasets: chartData.map((dataset: ChartDataSet) => {
      return {
        type: dataset.chartType as any,
        label: `${dataset.label}${dataset.showSum ? `: ` + dataset.sum : ``}`,
        backgroundColor: dataset.colors.map(
          (color: Color) => 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')',
        ),
        borderColor: dataset.style.borderColor,
        borderWidth: dataset.style.borderWidth,

        showLine: dataset.style.showLine,
        pointStyle: dataset.style.pointStyle,
        hoverBorderWidth: dataset.style.borderWidth
          ? dataset.style.borderWidth + 1
          : dataset.style.borderWidth,

        fill: dataset.style.fill,
        data: dataset.y.map((item: any) => item),
      };
    }),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
      xAxes: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
    },
    plugins: {
      legend: displayLegend,
    },
    title: {
      display: true,
      text: chartTitle ? chartTitle : '',
    },
    tooltip: {
      filter: function (tooltipItems: any) {
        if (tooltipItems.dataset.label === 'Comments') {
          return false;
        } else {
          return true;
        }
      },
    },
  };

  return (
    <>
      <div
        style={{
          height: 'auto',
          width: '100%',
          overflowX: 'auto',
        }}
      >
        <ResizableBox height={400} width={visualViewport!.width * 0.84}>
          <Chart
            ref={chartRef}
            type="bar"
            data={preparedData}
            options={options}
            onClick={(event: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => {
              if (!chartRef || !onClick) return;
              // console.log(onClick(getElementsAtEvent(chartRef.current!, event)));
              onClick(getElementAtEvent(chartRef.current!, event));
            }}
          />
        </ResizableBox>
      </div>
    </>
  );
}
